import { createContext, useContext } from 'react';

export interface HelpContextValue {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const HelpContext = createContext<HelpContextValue | null>(null);

/** Access the in-app help drawer controls. Must be used within a HelpProvider. */
export function useHelp(): HelpContextValue {
  const ctx = useContext(HelpContext);
  if (!ctx) throw new Error('useHelp must be used within a HelpProvider');
  return ctx;
}
